module.exports = __webpack_public_path__ + "static/media/logo-parceiro-ibbl.40fbdbfa.webp";